export default "__VITE_ASSET__Dc6F1a3$__"